import SectionLabel from '@/pages/home/components/SectionLabel';
import { threadSteps } from '@/mocks/homeData';

export default function ThreadMap() {
  return (
    <section id="threads" className="border-b border-background-200 bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionLabel
          index="05"
          kicker="THREADS · 脉络拆解"
          title="一条专题是怎么被整理出来的"
          desc="黑料六点每日栏目固定按这四步走，所以每条专题的结构一致，看起来不用重新适应。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {threadSteps.map((step) => (
            <div key={step.no} className="relative rounded-lg border border-background-200 bg-background-100 p-5">
              <span className="font-heading text-3xl font-bold text-primary-500">{step.no}</span>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm text-foreground-600">{step.desc}</p>
              <span className="absolute right-4 top-5 flex h-6 w-6 items-center justify-center rounded-full bg-background-50 text-foreground-400">
                <i className="ri-node-tree" />
              </span>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-lg border border-secondary-200 bg-secondary-100 px-6 py-5 md:flex-row">
          <p className="text-sm text-secondary-900">
            整理好的专题会进入<strong className="mx-1 font-semibold">黑料六点固定栏目</strong>，按日期归入往期归档。
          </p>
          <a
            href="#topics"
            className="flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-secondary-900"
          >
            看看今天的整理
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}